<template>
  <div class="footer-container">
    <img :src="footerImage" class="footer-image" alt="Footer" />
  </div>
</template>

<script>

export default {
  name: "CompanyFooter",
  computed: {
    footerImage() {
      const companyId = this.$session.get("companyId");
      const exts = ["png", "jpg", "jpeg"];

      // Try each extension
      for (const ext of exts) {
        try {
          return require(`@/assets/images/company${companyId}/footer.${ext}`);
        } catch (e) {
          // continue
        }
      }

      // If no footer image found → return null (do not display anything)
      return null;
    }
  }
};
</script>
